export default class DeleteTeam {
  constructor(context) {
    this.context = context;
  }

  run(teamId) {
    this.context.stores.teams.setPendingDelete(teamId);
    this.context.gateways.team.remove(teamId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/teams/delete_team.js